import gql from 'graphql-tag';

const UPDATE_STAGE = gql`
  mutation Mutation($deviceSerialNo: String!, $stage: deviceStage!) {
    updateStage(deviceSerialNo: $deviceSerialNo, stage: $stage) {
      code
    }
  }
`;

export default UPDATE_STAGE;
